<template>
  <div class="wrapper">
    <AlarmHeader :point-name="pointName"></AlarmHeader>
    <AlarmPointSidebar></AlarmPointSidebar>
    <div class="content-box" :class="{'content-collapse':collapse}">
      <div class="content">
        <transition name="move" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import AlarmHeader from './AlarmHeader'
  import AlarmPointSidebar from './AlarmPointSidebar'
  import bus from './bus'
  import myDate from '../../../../public/js/date.format'
  export default {
    name: 'AlarmPointHome',
    data(){
      return {
        collapse: false,
        alarmPointId:'',
        devID:'',
        startTime:'',
        endTime:'',
        pointName:'',
        // 查看警报点静态信息
        GetStaticInformation:{
          "version": 1,
          "method": "alarmpoint2.GetStaticInformation",
          "params": {
            "alarmPointId":"#"
          },
          "token": "#",
          "id": 0
        },
      }
    },
    methods:{
      // 获取警报点静态数据
      getStaticInfomation(){
        this.GetStaticInformation.params.alarmPointId = this.alarmPointId;
        this.GetStaticInformation.token = this.$store.state.token;
        console.log('查看警报点静态信息请求');
        console.log(this.GetStaticInformation);
        this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res=>{
          console.log('查看警报点静态信息请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: '获取警报点信息成功'
            })
            // this.AlarmPointStaticInfomation = res.data;
            //TODO:把警报点静态信息放入vuex中
            this.$store.commit('setAlarmPointStaticInfomation', res.data);
            this.pointName = res.data.result.pointName;
            this.devID = res.data.result.devID;
            sessionStorage.setItem("devIDForHardInfo",this.devID)
            this.$store.commit('setPointName', this.pointName);
            console.log('vuex中的静态信息');
            console.log(this.$store.state.AlarmPointStaticInfomation);
          }else{
            this.$message({
              type:'error',
              message: '获取警报点信息失败，' + res.data.error.message
            })
          }
        })
      }
    },
    components: { AlarmPointSidebar, AlarmHeader },
    created(){

      bus.$on('collapse', msg => {
        this.collapse = msg;
      })
      var query = window.location.toString();
      let id = '';
      let startTime = '';
      let endTime = '';
      //this.alarmPointId = localStorage.getItem('alarmManagerID');
      if(query.indexOf('&') ==-1){
        id = query.substring(query.indexOf('=') + 1);
        endTime = new Date().format('Y-m-d H:i:s')
        startTime = new Date(new Date() - 1000 * 60 * 60 * 24).format('Y-m-d H:i:s');
        this.alarmPointId = id;
      }if(query.indexOf('&') !=-1){
        id = query.substring(query.indexOf('=') + 1,query.indexOf('&'));
        let id1 = query.substring(query.indexOf('?') + 1)
        let array = id1.split('&')
        startTime = array[1].substring(array[1].indexOf('=')+1).split('%3A').join(":").split('%20').join(" ")
        endTime = array[2].substring(array[2].indexOf('=')+1).split('%3A').join(":").split('%20').join(" ")
        this.alarmPointId = localStorage.getItem("alarmPointIDForSub")
      };
      this.startTime = startTime;
      this.endTime = endTime;
      sessionStorage.setItem('alarmPointId',this.alarmPointId);
      sessionStorage.setItem('startTime', this.startTime);
      sessionStorage.setItem('endTime', this.endTime);
      this.getStaticInfomation();// 获取警报点静态信息
    },
  }
</script>

<style scoped>

</style>
